import { render, staticRenderFns } from "./HistoryAndMoreDetails.vue?vue&type=template&id=1e309101&"
import script from "./HistoryAndMoreDetails.vue?vue&type=script&lang=js&"
export * from "./HistoryAndMoreDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports